/* eslint-disable */
import {
  queryParamsMap,
  SelectPickerTypes,
} from '../../../app/common/components/forms/select-picker/select-picker-types.enum';
import { EVENTS } from '../../../app/constants/events';
import { Cluster, ClusterTypes } from '../../../app/clusters/clusters.models';
import { loadSelectPickerItems } from '../../../app/common/store/select-picker.actions';

xplenty.service('selectPickerModal', [
  '$rootScope',
  '$compile',
  '$timeout',
  'modalService',
  'ngrxStoreService',
  function ($rootScope, $compile, $timeout, modalService, ngrxStoreService) {
    let currentConnectionTypes = '';
    return {
      setConnectionTypes(types) {
        currentConnectionTypes = types;
      },
      editItem(item, type, selectPickerId) {
        const $newScope = $rootScope.$new();
        $newScope.$modalBody = angular.element('.modal-body');

        const isModal = $newScope.$modalBody.length > 0;

        const setOption = function (isCluster) {
          if (isCluster) {
            ngrxStoreService.dispatch(
              loadSelectPickerItems({
                id: selectPickerId,
                itemType: SelectPickerTypes.cluster,
                params: queryParamsMap[SelectPickerTypes.cluster],
              }),
            );
          } else {
            ngrxStoreService.dispatch(
              loadSelectPickerItems({
                id: selectPickerId,
                itemType: SelectPickerTypes.connection,
                params: { ...queryParamsMap[SelectPickerTypes.connection], type: currentConnectionTypes },
              }),
            );
          }

          if (isModal) {
            $rootScope.$broadcast(EVENTS.MODAL_PANEL_CLOSE);
            $modalPanel.remove();
          }
          $timeout(function () {
            $newScope.$destroy();
          });
        };

        let directive;

        if (type === 'connection') {
          directive =
            '<connection-form [item]="connection" on-connection-created="onConnectionCreated($event)" bind-is-in-modal="true" />';
          $newScope.connection = { ...item };
          $newScope.itemObject = {
            directive,
          };
          $newScope.onConnectionCreated = (connection) => {
            $rootScope.$broadcast(EVENTS.CONNECTION_CREATED, connection);
            setOption();
          };
        } else if (type === 'cluster') {
          directive =
            '<cluster-form [item]="cluster" bind-disable-modal-close="true" on-cluster-created="onClusterCreated($event)" />';
          $newScope.cluster = item;
          $newScope.itemObject = {
            directive,
          };
          $newScope.onClusterCreated = () => {
            setOption(true);
          };
        }

        if (isModal) {
          var $modalPanel = $compile('<modal-panel modal-body="$modalBody" item-object="itemObject"></modal-panel>')(
            $newScope,
          );

          if (type === 'connection') {
            $newScope.$on(EVENTS.CONNECTION_CREATED, () => setOption());
            $newScope.$on(EVENTS.CONNECTION_UPDATED, () => setOption());
          }
        } else {
          const modalSettings = {
            titleText: 'Edit',
            closeButtonText: 'Close',
            saveButtonText: 'Save',
            hasPadding: false,
            hasScroll: false,
            thin: ['connection'].indexOf(type) <= -1,
            hasFooter: false,
            onSave() {},
            onClose() {},
          };

          modalService.showModal(modalSettings, directive, $newScope);
        }
      },

      createNew(connection, type, selectPickerId) {
        if (connection) {
          this.editItem(connection, type, selectPickerId);
        } else if (this.type === SelectPickerTypes.connection && this.connectionTypes.length === 1) {
          this.editItem(this.connectionTypes[0], type, selectPickerId);
        } else {
          this.editItem(
            {
              name: '',
              type: ClusterTypes.sandbox,
              nodes: 1,
              terminate_on_idle: true,
              time_to_idle: 600,
              reuse_cluster_strategy: 'any',
            },
            type,
            selectPickerId,
          );
        }
      },
    };
  },
]);
